/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  if (!$(".card-articles").length) {
    $(".section-recommended-articles").addClass("d-none");
  }
});
